import { Header1 } from './Header1'
import { Header2 } from './Header2'
import { Header3 } from './Header3'
import { Header4 } from './Header4'
import { Header5 } from './Header5'
import { Header6 } from './Header6'

export const Headers = {
  One: Header1,
  Two: Header2,
  Three: Header3,
  Four: Header4,
  Five: Header5,
  Six: Header6,
}

export { Body } from './Body'
export { Header } from './Header'
export { Hero } from './Hero'
export { Header1 } from './Header1'
export { Header2 } from './Header2'
export { Header3 } from './Header3'
export { Header4 } from './Header4'
export { Header5 } from './Header5'
export { Header6 } from './Header6'
